export default __webpack_public_path__ + "static/media/icon-park-outline_ticket.e66ed146.svg";